import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'

// Import the Auth0 configuration and plugin
import { domain, clientId, audience } from "../auth_config.json"
import { Auth0Plugin } from "@/auth/auth0-plugin"

Vue.config.productionTip = false

//axios.defaults.baseURL = 'http://localhost:5000'
axios.defaults.baseURL = 'https://api.sportofollow.io/'

// Install the authentication plugin
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    )
  },
})

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
